import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import AddIcon from "../../UIComponents/AddIcon";
import { DownloadAttachment } from "../../Actions/AttachmentAPI";
import { withRouter } from "react-router-dom";
import { getMakeSearchList } from "../../Actions/lookupAPI";
import axios from "axios";
import API from "../../helpers/api";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import swal from "sweetalert";
import { postModalAttachment, deleteAttachmentInBucket} from "../../Actions/CommonAPI";
import { confirmAlert } from "react-confirm-alert";
import { ExpandLessOutlined } from "@material-ui/icons";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));

var fileDatas = [];

class MakeAdd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      isModelNew: true,
      lookUpType: "make",
      models: [],
      ModelDetails: {
        Id: 0,
        modelName: "",
        attachmentName:"",
        attachmentGuid:"",
      },
      MakeModelDetails: {
        make: "",
        modelList: [],
      },
      file: "",
      fileName: "",
    };
   
    this.AddMake = this.AddMake.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.ClearModel = this.ClearModel.bind(this);
    this.showModal = this.showModal.bind(this);
  }

  componentDidMount(){
    this.props.dispatch({ type: "SubBannerTitle", data: "Make And Model" });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { ModalAttachment, dispatch } = nextProps;
    if (ModalAttachment) {
      prevState.ModelDetails.attachmentName = ModalAttachment.FileName;
      prevState.ModelDetails.attachmentGuid = ModalAttachment.Guid;
    }
if (prevState.file !== "") {
      dispatch(postModalAttachment(prevState.file));
      prevState.file = "";
    }
  }

  AddMake() {
    
    const { dispatch, t } = this.props;
    if (this.state.MakeModelDetails.make !== "" && this.state.models.length>0) {
      let url1 = `${API.lookupExist}?LookupType=${this.state.lookUpType}&LookupValue=${this.state.MakeModelDetails.make}`;
      axios
        .get(url1)
        .then((response) => {
          if (response.data === true) {
            this.state.MakeModelDetails.modelList = this.state.models;
            let lookup = {
              lookUpToAdd: "lookup",
              lookUpType: this.state.lookUpType,
              lookUpValue: this.state.MakeModelDetails.make,
              createdBy: currentuser.name,
              IntervalYear: 0,
              modelList: this.state.MakeModelDetails.modelList,
            };
            let url = `${API.PostMakeModel}`;
            axios
              .post(url, lookup)
              .then((response) => {
                if (response.data) {
                  let searchData = {
                    Make: "",
                    Model: "",
                    PageNumber: 1,
                    PageSize: 20,
                  };
                  
                  if (fileDatas.length > 0) {
                    this.props.dispatch(deleteAttachmentInBucket(fileDatas));
                    fileDatas = [];
                  } 
                  dispatch(getMakeSearchList(searchData));
                  this.CancelAddMake();
                  toast.success(`${t("CommonText.CommonAdd")}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                }

                dispatch({
                  type: "postMakeModelDetailSuccess",
                  data: response.data,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "postMakeModelDetailFailure",
                  error: "ERROR",
                });
              });
          } else if (response.data === false) {
            // swal("Error!", `${t("MakeAndModelScreen.WarningMsg")}`, "warning");
            swal({
              title: t('SwalError.ErrorTitle'), 
              text: t("MakeAndModelScreen.WarningMsg"),  
              icon: 'warning',  
              buttons: {
                confirm: {
                  text: t('confirmAlertMessage.Ok')
                }
              }
            });
            this.state.MakeModelDetails.make = "";
            this.setState({});
          }
          dispatch({
            type: "getMakeExistListSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "getMakeExistListFailure",
            data: "error",
          });
        });
    }
    else{
      if(this.state.MakeModelDetails.make==""){
      swal({
        title: t('SwalError.ErrorTitle'), 
        text: t('SwalError.EquipmentMake'),  
        icon: 'warning',  
        buttons: {
          confirm: {
            text: t('confirmAlertMessage.Ok')
          }
        }
    })
  }
  else if(this.state.models.length==0){
    swal({
      title: t('SwalError.ErrorTitle'), 
      text: t('SwalError.EquipmentModel'),  
      icon: 'warning',  
      buttons: {
        confirm: {
          text: t('confirmAlertMessage.Ok')
        }
      }
  })
  }
  }
}
  handleInputChange(e, field) {
    const nodeName = e.target.name;
    if (nodeName === "make") {
      this.state.MakeModelDetails[nodeName] = e.target.value;
    } else if (nodeName === "modelName") {
      this.state.ModelDetails[nodeName] = e.target.value;
    }else if (nodeName === "fileName") {
      let filename = e.target.files[0].name;
      this.setState({
        file: e.target.files[0],
        fileName: e.target.files[0].name,
      });
    }

    this.setState({});
  }

  ClearInput() {
  const {dispatch}=this.props;
   
    //this.props.dispatch(deleteAttachmentInBucket(this.state.ModelDetails.attachmentGuid,this.state.ModelDetails.attachmentName));
    let obj = {
      filename : this.state.ModelDetails.attachmentName,
      guid : this.state.ModelDetails.attachmentGuid,
    }
    fileDatas.push(obj);
    this.state.ModelDetails.attachmentName="";
    this.state.ModelDetails.attachmentGuid="";
    this.state.file="";
    this.state.fileName="";
    this.setState({ },()=>{
      console.log(this.state.ModelDetails)
    });
    dispatch({ type: "postModalAttachmentUploadSuccess", data: "" });
  }
  showModal = (ModelId, isModelNew) => {
    var arrayStroage = this.state.models;
    var arrayLength = arrayStroage.length;
    if (ModelId > 0) {
      let response = this.state.models.filter((item) => item.Id == ModelId);
      let editModelDetails = response[0];
      this.setState(
        {
          modalIsOpen: !this.state.modalIsOpen,
          isModelNew: isModelNew,
          ModelDetails: {
            Id: parseInt(editModelDetails.Id),
            modelName: editModelDetails.modelName,
            attachmentName:editModelDetails.attachmentName,
            attachmentGuid:editModelDetails.attachmentGuid,
          },
          fileName:editModelDetails.attachmentName,
        },
        () => console.log(this.state.isModelNew)
      );
    } else {
      fileDatas = [];
      this.setState(
        {
          isModelNew: isModelNew,
          ModelDetails: {
            Id: arrayLength >= 0 ? arrayLength + 1 : 0,
          },
          modalIsOpen: !this.state.modalIsOpen,
        },
        () => {
          console.log(this.state.ModelDetails.Id);
          this.ClearModel();
        }
      );
    }
  };
  ModelValidation = () => {
    var Model = this.state.ModelDetails.modelName;
    if (Model != "") {
      this.UploadModel();
    }
  };
  UploadModel = async () => {
    var product = {
      Id: parseInt(this.state.ModelDetails.Id),
      modelName: this.state.ModelDetails.modelName,
      attachmentName:this.state.ModelDetails.attachmentName,
      attachmentGuid:this.state.ModelDetails.attachmentGuid,
};
    let GetModel = this.state.models;
    let temp = GetModel.filter((item) => item.Id === product.Id) || [];
    if (temp.length > 0) {
      GetModel.forEach((ele, index) => {
        if (ele.Id == product.Id) {
          GetModel[index] = product;
        }
      });
    } else {
      GetModel.push(product);
    }
    localStorage.setItem("model", JSON.stringify(GetModel));
    var Information = JSON.parse(localStorage.getItem("model"));
    this.setState({ models: Information, modalIsOpen: false }, () => {
      if (this.state.isModelNew) {
        this.ClearModel();
      }
    });
  };
  ClearModel = () => {
    const {dispatch}=this.props;
    this.setState(
      {
        ModelDetails: {
          Id: this.state.ModelDetails.Id,
          modelName: "",
          attachmentName:"",
          attachmentGuid:""
        },
        file:"",
        fileName:"",
      },
      () => {
        console.log(this.state.ModelDetails);
      }
    );
    dispatch({ type: "postModalAttachmentUploadSuccess", data: "" });
  };
  deleteModel = (index) => {
    const { t } = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const models = [...this.state.models];
            models.splice(index, 1);
            this.setState({ models: models });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    const { t } = this.props;
    return (
      <div className="pb-3">
        <Modal
          size="lg"
          show={this.state.modalIsOpen}
          onHide={() => {
            this.showModal(0, true);
          }}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
          className="borderCondition"
        >
          <Modal.Header
            className="ClosebtnColor"
            closeButton
            style={{ backgroundColor: "#1a3464", color: "white" }}
          >
            <Modal.Title id="example-modal-sizes-title-sm">
              {t("ShipEquipmentStatusScreen.Model")}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div className={"col-lg-6"}>
                <label className="form-label required">
                  {t("ShipEquipmentStatusScreen.Model")}
                </label>
                <br></br>
                <input
                  className="form-control"
                  type="text"
                  name="modelName"
                  value={this.state.ModelDetails.modelName}
                  placeholder={t("ShipEquipmentStatusScreen.Model")}
                  onChange={(e) => this.handleInputChange(e)}
                ></input>
              </div>
              <div className="col-lg-6">
                  <label className="form-label">{t("FlagScreen.Attachment")}</label>
                  <br></br>
                  <div class="input-group ">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                      {t("CommonText.BrowseFile")}
                        <input
                          type="file"
                          id="files"
                          name="fileName"
                          style={{ marginRight: 40 }}
                          onChange={(e) => this.handleInputChange(e)}
                          onClick={(event) => {
                            event.currentTarget.value = null;
                          }}
                        />
                      </span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      placeholder={t("CommonText.Nofilechoosen")}
                      value={this.state.fileName}
                    />
                    {this.state.fileName ? (
                      <div
                        class="input-group-append"
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          class="fa fa-times input-group-text padding-top-9px"
                          aria-hidden="true"
                          onClick={() => this.ClearInput()}
                        ></i>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
            </div>
            <div className="row">
              <div className="col-lg-6 ml-auto">
                <div
                  className="search-btn-col pt-3"
                  style={{ textAlign: "end" }}
                >
                  <button
                    type="button"
                    id="SBMCAdd"
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-2"
                    style={{ backgroundColor: "rgb(26, 52, 100)" }}
                    onClick={() => this.ModelValidation()}
                  >
                    {this.state.isModelNew
                      ? `${t("ShipManagementContent.Add")}`
                      : `${t("EquipmentServiceTypes.Update")}`}
                  </button>
                  <button
                    type="button"
                    className="btn btn-light text-uppercase txtside-btn txtht-btn mt-2 ml-2"
                    data-dismiss="modal"
                    onClick={() => this.showModal(0, true)}
                  >
                    {t("ComplianceandBudgetScreen.Cancel")}
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {this.renderCardData()}
      </div>
    );
  }

  renderCardData() {
    const { t } = this.props;
    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3 ">
          <div className="col-lg-12">
            <div className="panel-box">
              <div
                className="card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }}
              >
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1a3464",
                    color: "white",
                  }}
                >
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}
                  >
                    {t("MakeAndModelScreen.AddMake")}
                  </h5>
                </div>
              </div>
              <div className="row search-filter-box">
                <div className="col-lg-4">
                  <label className="form-label required">
                    {t("ShipEquipmentStatusScreen.Make")}
                  </label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="make"
                    value={this.state.MakeModelDetails.make}
                    placeholder={t("ShipEquipmentStatusScreen.Make")}
                    onChange={(e) => this.handleInputChange(e)}
                  ></input>
                </div>
              </div>
              <div className="search-filter-box">
                <div
                  className="card mt-2 MM-card-header"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body flex"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h6
                      className="card-title ml-2 mt-2 f2"
                      style={{ color: "092a51" }}
                    >
                      {t("ShipEquipmentStatusScreen.Model")}
                    </h6>
                    <div
                      className="m-1 flex"
                      onClick={() => this.showModal(0, true)}
                    >
                      <span className="mt-1">
                        {t("ShipManagementContent.Add")}
                      </span>
                      <AddIcon />
                    </div>
                  </div>
                </div>
                <div className="search-filter-box">
                  {this.renderModelCard()}
                </div>
                <div className="col-lg-12 search-filter-box">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                      type="submit"
                      onClick={() => this.AddMake()}
                    >
                      {" "}
                      {t("ComplianceandBudgetScreen.Submit")}{" "}
                    </button>

                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.CancelAddMake()}
                    >
                      {" "}
                      {t("ComplianceandBudgetScreen.Cancel")}{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderModelCard = () => {
    const { t } = this.props;
    const ModelArray = this.state.models;
    return ModelArray && ModelArray.length ? (
      ModelArray.map((item, index) => {
        return (
          <div
            className="card click m-3"
            style={{
              backgroundColor: "#f0f0f0",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-9 col-md-10 col-9 m-auto">
                    <div className="row">
                      <div className="col-sm-6">
                        <span>
                          <strong>
                            {t("ComplianceandBudgetScreen.ModelName")}:{" "}
                          </strong>
                          {item.modelName}
                        </span>
                      </div>
                      <div className={"col-sm-6"} >
                          <span>
                            <strong>{t("FlagScreen.Attachment")} : </strong>
                            <span className="italicFont ">
                              {item.attachmentName}{" "}
                            </span>
                            {item.attachmentName ? (
                              <i
                                className="fa fa-download click ml-1"
                                onClick={() =>
                                  this.DownloadDoc(
                                    item.attachmentName,
                                    item.attachmentGuid
                                  )
                                }
                                aria-hidden="true"
                                style={{
                                  color: " #1a3464",
                                  fontSize: "1.2rem",
                                }}
                              ></i>
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-3 col-3 m-auto">
                    <div className="text-right">
                      <i
                        className="fa fa-edit fa-lg click m-1 px-1"
                        onClick={() => this.showModal(item.Id, false)}
                        aria-hidden="true"
                        style={{ color: " #1a3464", fontSize: "1.8rem" }}
                      ></i>
                      <i
                        className="fa fa-trash click m-1 px-2"
                        onClick={() => this.deleteModel(index)}
                        aria-hidden="true"
                        style={{ color: " #1a3464", fontSize: "1.8rem" }}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
    ) : (
      <div
        className="card m-3"
        style={{ overflow: "hidden", position: "relative" }}
      >
        <div class="container">
          <h6 className="resource-list-title no-item-card">
            !--{t("MakeAndModelScreen.NoItem")}--!
          </h6>
        </div>
      </div>
    );
  };
  DownloadDoc(attachmentName, attachmentGuid) {
    this.props.dispatch(DownloadAttachment(attachmentName, attachmentGuid));
  }
  CancelAddMake() {    
    fileDatas = [];
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/LookupMakeAndModel");
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    ModalAttachment: state.lookupReducer.ModalAttachment,
  };
}
export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(MakeAdd))
);
